import script from "./BarChart-horizontal.vue?vue&type=script&setup=true&lang=js"
export * from "./BarChart-horizontal.vue?vue&type=script&setup=true&lang=js"

import "./BarChart-horizontal.vue?vue&type=style&index=0&id=4d95bd52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d95bd52"]])

export default __exports__